export default __webpack_public_path__ + "5e9a2c22bc78c456164c49dce002cef7.png";